import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRecord = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#979797"
      transform="translate(1 1)"
    >
      <circle cx={11} cy={11} r={11} />
      <path d="m10.756 6.745 3.732 3.718a1 1 0 0 1-.066 1.477l-3.733 3.104a1 1 0 0 1-1.639-.769V7.453a1 1 0 0 1 1.706-.708z" />
    </g>
  </svg>
);
const Memo = memo(SvgRecord);
export default Memo;
